import { useCallback } from 'react';
import { FsEvent } from '@fullstory/fs-script-api';
import { useMetricFetcher } from './useOptimizeUtil';
import { getMetricForEvent } from '@fullstory/signal-studio-context';
import { makePlatformSelectorDeps } from '../utils';
import { useNamedElements } from './useNamedElements';

export const useMeasureSelector = () => {
  const fetchMetric = useMetricFetcher();
  const { namedElements } = useNamedElements();

  const measureSelector = useCallback(
    async (selector: string) => {
      const event = { primary: null, deps: makePlatformSelectorDeps({ selector, platforms: [] }) };
      const metric = getMetricForEvent({ event, property: 'element', limit: 50, noFallback: true });
      const result = await fetchMetric(metric);
      const matchingElementIds =
        result[0]?.data?.table?.map(row => row.groups.map(g => g.groupId)).flat() || [];
      const matchingElementNames = matchingElementIds
        .map(id => namedElements.find(e => e.namedElement?.id === id)?.namedElement?.name || '')
        .filter(s => s);
      FsEvent.recordCustomEventV2('existing-elements', {
        count: matchingElementNames.length,
        names: matchingElementNames.join(','),
      });
    },
    [fetchMetric, namedElements],
  );

  return { measureSelector };
};
